var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 570 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of the Marshall Islands") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 300,
    width: 570,
    fill: "#003893"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,295.2V288L570,35V122.4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,290.4V285.6L570,4.8V63.6z",
    fill: "#dd7500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(109.536,109.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-93 5.59,0H-5.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r1",
    d: "M0,-66.588 6.824,0H-6.824z",
    transform: "rotate(15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1",
    transform: "rotate(15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1",
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r1",
    transform: "rotate(60)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r6",
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r6",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r6",
    transform: "rotate(270)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/mh.c47cb4a567a20dc96975f1ce18ab1b4b.svg";
export { ForwardRef as ReactComponent };